import { ButtonContained } from "shared/ui/buttons/buttonContained"
import { LoginContainer, LoginForm } from "./styles"
import { Input } from "shared/ui/Inputs/Input"
import { Typography } from "shared/ui/typography"
import { useCallback, useState } from "react"
import { authorize } from "entities/user/auth"
import { useAppDispatch } from "shared/lib/store"

export const Login = () => {
    const dispatch = useAppDispatch();
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = useCallback((e: React.SyntheticEvent) => {
        e.preventDefault();
        if (login&&password) {
          dispatch(authorize({ username: login, password: password }))
        }
    }, [login, password, dispatch])

    return (
        <LoginContainer>
            <LoginForm onSubmit={handleSubmit}>
                <Typography mode="medium" style={{ margin: 'auto' }}>Войти в аккаунт SlotBy</Typography>
                <Input enterKeyHint="go" placeholder="Имя пользователя" value={login} onChange={e => setLogin(e.target.value)} />
                <Input enterKeyHint="go" placeholder="Пароль" type="password" value={password} onChange={e => setPassword(e.target.value)} />
                <ButtonContained>Войти →</ButtonContained>
            </LoginForm>
        </LoginContainer>
    )
}